import "./Users.css";

import * as m from "../../../../model/model";

import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import {
  createUserThunk,
  loadUserThunk,
  loadUsersThunk,
} from "../../../../store/slices/adminThunks";

import { CUsers } from "../../../../model/classes/CUsers";
import { NewUserModal } from "../../../../modals/NewUserModal";
import React from "react";
import ReactDOM from "react-dom";
import UserPanel from "./UserPanel";
import { klassi } from "../../../../utils/utils";
import { useModal } from "../../../../context/ModalContext";

export default function Users() {
  const data = useAppSelector((state: RootState) => state.admin.users);
  const user = useAppSelector((state: RootState) => state.admin.selectedUser);
  const [users, setUsers] = React.useState<CUsers>();
  const [search, setSearch] = React.useState("");
  const dispatch = useAppDispatch();
  const [width, setWidth] = React.useState(240);
  const isResizing = React.useRef(false);
  const { showModal } = useModal();

  React.useEffect(() => {
    dispatch(loadUsersThunk());
  }, [dispatch]);

  React.useEffect(() => {
    if (data) setUsers(new CUsers(data));
  }, [data]);

  const onUserClick = (user: m.FbUser) => {
    dispatch(loadUserThunk(user.key));
  };

  const startResize = (e: any) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", stopResize);
  };

  const handleMouseMove = (e: any) => {
    if (!isResizing.current) return;
    setWidth(e.clientX);
  };

  const stopResize = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", stopResize);
  };

  const renderFooterContent = () => {
    const onClick = () => {
      showModal(
        <NewUserModal
          onConfirm={(newUser) => {
            dispatch(createUserThunk(newUser));
          }}
        />
      );
    };
    return ReactDOM.createPortal(
      <>
        <button className="loa-button" onClick={onClick}>
          New User...
        </button>
      </>,
      document.getElementById("loa-admin-footer") || document.body
    );
  };

  return (
    <>
      <div className="admin-users" style={{ width }}>
        <div className="users-title">
          <input
            value={search}
            onChange={(evt) => setSearch(evt.currentTarget.value)}
          />
        </div>
        <ul className="user-list">
          {users?.filter({ search }).map((usr) => (
            <li
              key={usr.key}
              className={klassi(
                { selected: usr.key === user?.key },
                "user-item"
              )}
              onClick={() => onUserClick(usr)}
            >
              {usr.name}
            </li>
          ))}
        </ul>
      </div>
      <div className="panel-resize-handle" onMouseDown={startResize} />
      <UserPanel />
      {renderFooterContent()}
    </>
  );
}
